<template>
  <div class="public-box">
    <pull-to>
    <div class="public-message">
      <div class="mes-title">收款账户</div>
      <ul class="mes-list">
        <li v-for="(item,index) in publicList" :key="index">
          <div>{{item.key}}</div>
          <div>{{item.message}}</div>
        </li>
      </ul>
    </div>
    <div class="public-form">
      <div class="form-title">付款账户</div>
      <div class="form-list">
        <div>企业名称</div>
        <cube-input class="cube-input" v-model="formParams.groupName"></cube-input>
      </div>
      <div class="form-list">
        <div class="require">企业负责人</div>
        <cube-input class="cube-input" v-model="formParams.principal" placeholder="请输入企业负责人"></cube-input>
        <validator v-model="validator[0]" :model="formParams.principal" :rules="rules[0]" ref="validator1"></validator>
      </div>
      <div class="form-list">
        <div class="require">联系电话</div>
        <cube-input class="cube-input" v-model="formParams.phone" :maxlength="11" placeholder="请输入联系电话"></cube-input>
        <validator v-model="validator[1]" :model="formParams.phone" :rules="rules[0]" ref="validator2"></validator>
      </div>
      <div class="form-list">
        <div class="require">开户行</div>
        <cube-input class="cube-input" v-model="formParams.bankNo" placeholder="请输入开户行"></cube-input>
        <validator v-model="validator[2]" :model="formParams.bankNo" :rules="rules[0]" ref="validator3"></validator>
      </div>
      <div class="form-list">
        <div class="require">开户行地址</div>
        <cube-input class="cube-input" v-model="formParams.bankAddress" placeholder="请输入开户行地址"></cube-input>
        <validator v-model="validator[3]" :model="formParams.bankAddress" :rules="rules[0]" ref="validator4"></validator>
      </div>
      <div class="form-list">
        <div class="require">付款账号</div>
        <cube-input class="cube-input" v-model="formParams.payNo" placeholder="请输入付款账号"></cube-input>
        <validator v-model="validator[4]" :model="formParams.payNo" :rules="rules[0]" ref="validator5"></validator>
      </div>
      <div class="form-list">
        <div class="require">付款金额</div>
        <cube-input class="cube-input" v-model="formParams.price" type="number" placeholder="请输入付款金额"></cube-input>
        <validator v-model="validator[5]" :model="formParams.price" :rules="rules[1]" ref="validator6"></validator>
      </div>
      <div class="form-list">
        <div class="require">付款事项</div>
        <cube-input class="cube-input" v-model="formParams.payMatters" placeholder="请输入付款事项"></cube-input>
        <validator v-model="validator[6]" :model="formParams.payMatters" :rules="rules[0]" ref="validator7"></validator>
      </div>
      <Button @click="submit">提交</Button>
    </div>
    </pull-to>
  </div>
</template>

<script>
import { Style, Input, Button, Toast, Validator } from 'cube-ui';
import { mapGetters } from 'vuex';
import apis from 'api/index';
import PullTo from 'vue-pull-to';
import { commonMixin } from 'common/js/mixin';

export default {
  mixins: [commonMixin],
  components: {
    cubeInput: Input,
    Button,
    Validator,
    PullTo,
  },
  data() {
    return {
      publicList: [
        { key: '企业名称:', message: '苏州万店掌网络科技有限公司' },
        { key: '企业负责人:', message: '周圣强' },
        { key: '联系电话:', message: '18928883838' },
        { key: '企业名付款账号:', message: '2121310200099900900' },
      ],
      validator: [undefined,undefined,undefined,undefined,undefined,undefined,undefined], // 验证绑定的值，true/false
      rules: [
        { required: true, },
        { required: true, type: 'number',}
      ], // 验证规则
      formParams: {
        groupName: '', // 企业名称
        principal: '', // 企业负责人
        phone: '', // 联系电话
        bankNo: '', // 开户行
        bankAddress: '', // 开户行地址
        payNo: '', // 付款账号
        price: null, // 付款金额
        payMatters: '', // 付款事项
      }
    }
  },
  computed: {
    ...mapGetters(['userAllInfo'])
  },
  created() {
    this.formParams.groupName = this.userAllInfo.enterprise.name;
  },
  methods: {
    submit() {
      const valid1 = this.$refs.validator1.validate();
      const valid2 = this.$refs.validator2.validate();
      const valid3 = this.$refs.validator3.validate();
      const valid4 = this.$refs.validator4.validate();
      const valid5 = this.$refs.validator5.validate();
      const valid6 = this.$refs.validator6.validate();
      const valid7 = this.$refs.validator7.validate();
      Promise.all([valid1, valid2, valid3, valid4, valid5, valid6, valid7]).then(() => {
        if (this.validator.every(item => item)) { // 验证通过
          apis.payByPublic(JSON.stringify(this.formParams)).then(res => {
            this.showDialog('提交成功','alert' , () => {
              this.$router.go(-1);
            });
          }).catch(err => {
            console.error(err);
          })
        }
      })
    },
    resetForm() {
      this.formParams.groupName = this.userAllInfo.enterprise.name;
      this.formParams.principal = '';
      this.formParams.phone = '';
      this.formParams.bankAddress = '';
      this.formParams.payNo = '';
      this.formParams.bankNo = '';
      this.formParams.price = null;
      this.formParams.payMatters = '';
    },
    showToast(text) {
      const toast = this.$createToast({
        txt: text,
        type: 'correct'
      });
      toast.show();
    },
  }
}
</script>


<style lang="scss" scoped>
.public-box {
  position: absolute;
  top: 106px;
  left: 0;
  width: 96%;
  padding: 0px 2%;
  bottom: 0;
  overflow-y: scroll;
  .public-message {
    background: #fff;
    padding: 20px 15px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
  }
  .mes-title {
    margin-bottom: 20px;
  }
  .mes-list {
    font-size: 15px;
    color: #666;
    li {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
    }
  }
  .public-form {
    background: #fff;
    border-radius: 5px;
    margin-top: 20px;
    padding: 20px 15px;
    .form-title {
      margin-bottom: 20px;
    }
    .form-list {
      margin-bottom: 20px;
      div:first-child {
        font-size: 15px;
        color: #666;
        margin-bottom: 10px;
      }
      .cube-input {
        background: #FAFAFA;
      }
    }
  }
}
.require::after {
  content: '*';
  color: #e64340;
}
</style>
